// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LD35","col":"styles_col__lHRHK","actions":"styles_actions__37GOI","conflict":"styles_conflict__BTZjT"};